import { render } from "./imgGrid.vue?vue&type=template&id=2b27749c"
import script from "./imgGrid.vue?vue&type=script&lang=js"
export * from "./imgGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__